export enum SampleResultStatusEnum {
    DEFAULT = -1,
}
